export const exertionValues = [1, 2, 3, 4, 5, 6] as const;

export type Exertion = (typeof exertionValues)[number];

export enum Mood {
	VERY_BAD = 1,
	BAD = 2,
	OK = 3,
	GOOD = 4,
	VERY_GOOD = 5,
	EXCELLENT = 6,
}
export const moodValues = [Mood.VERY_BAD, Mood.BAD, Mood.OK, Mood.GOOD, Mood.VERY_GOOD, Mood.EXCELLENT] as const;
